import {BASE_URL, baseGetData, basePostData} from "./BaseApi";


// login
export const loginToAccountApi = async (data = {}) => {
    return basePostData(BASE_URL + '/api/admin/login', JSON.stringify(data));
}


// event
export const getLastEventApi = async () => {
    return baseGetData(`${BASE_URL}/api/admin/dashboard/event/last`)
}
export const getEventListApi = async (page, limit, query) => {
    return baseGetData(`${BASE_URL}/api/admin/dashboard/event/list?page=${page}&limit=${limit}&query=${query}`)
}
export const getEventInfoApi = async (event_id) => {
    return baseGetData(`${BASE_URL}/api/admin/dashboard/event/info?event_id=${event_id}`)
}
export const addNewEventApi = async (data) => {
    return basePostData(`${BASE_URL}/api/admin/dashboard/event/add`, data, true)
}
export const updateEventApi = async (data = {}) => {
    return basePostData(`${BASE_URL}/api/admin/dashboard/event/update`, data, true)
}
export const deleteEventApi = async (data = {}) => {
    return basePostData(`${BASE_URL}/api/admin/dashboard/event/delete`, JSON.stringify(data))
}


// tickets
export const getTicketListApi = async (page, limit, query) => {
    return baseGetData(`${BASE_URL}/api/admin/dashboard/ticket/list?page=${page}&limit=${limit}&query=${query}`)
}

export const getTicketInfoApi = async (ticket_id) => {
    return baseGetData(`${BASE_URL}/api/admin/dashboard/ticket/info?ticket_id=${ticket_id}`)
}


// plan
export const getPlanListApi = async () => {
    return baseGetData(`${BASE_URL}/api/admin/dashboard/plan/list`)
}
export const addNewPlanApi = async (data) => {
    return basePostData(`${BASE_URL}/api/admin/dashboard/plan/add`, JSON.stringify(data))
}
export const updatePlanApi = async (data) => {
    return basePostData(`${BASE_URL}/api/admin/dashboard/plan/update`, JSON.stringify(data))
}
export const deletePlanApi = async (data) => {
    return basePostData(`${BASE_URL}/api/admin/dashboard/plan/delete`, JSON.stringify(data))
}

//customers
export const getCustomerListApi = async (page, limit) => {
    return baseGetData(`${BASE_URL}/api/admin/dashboard/customer/list?page=${page}&limit=${limit}`)
}
export const getCustomerInfoApi = async (customer_id) => {
    return baseGetData(`${BASE_URL}/api/admin/dashboard/customer/info?customer_id=${customer_id}`)
}
export const addNewCustomerApi = async (data = {}) => {
    return basePostData(`${BASE_URL}/api/admin/dashboard/customer/add`, data, true)
}
export const updateCustomerApi = async (data = {}) => {
    return basePostData(`${BASE_URL}/api/admin/dashboard/customer/update`, data, true)
}
export const deleteCustomerApi = async (data = {customer_id: 0}) => {
    return basePostData(`${BASE_URL}/api/admin/dashboard/customer/delete`, JSON.stringify(data))
}

// about-us
export const getAboutInfoApi = async () => {
    return baseGetData(`${BASE_URL}/api/admin/dashboard/about/info`)
}
export const updateAboutInfoApi = async (data) => {
    return basePostData(`${BASE_URL}/api/admin/dashboard/about/update`, JSON.stringify(data))
}

// our-target
export const getVisionInfoApi = async () => {
    return baseGetData(`${BASE_URL}/api/admin/dashboard/vision/info`)
}
export const updateVisionInfoApi = async (data) => {
    return basePostData(`${BASE_URL}/api/admin/dashboard/vision/update`, JSON.stringify(data))
}


// subscribers
export const getSubscribersList = async (page, limit, query) => {
    return baseGetData(`${BASE_URL}/api/admin/dashboard/subscriber/list?page=${page}&limit=${limit}&query=${query}`)
}

